import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <div className='footer'>
      <p className='footer-heading'>~ Designed By Anas Aqeel ~</p>
    </div>
  )
}

export default Footer